/** PURE_IMPORTS_START ._ForkJoinObservable PURE_IMPORTS_END */
import { ForkJoinObservable } from './ForkJoinObservable';
export var forkJoin = ForkJoinObservable.create;
//# sourceMappingURL=forkJoin.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/forkJoin.js
// module id = 370
// module chunks = 0